var exports = {
  "kL": "FriendsSkeleton.module__container___QTRORD",
  "Em": "FriendsSkeleton.module__mainColumn___QTRORD",
  "wx": "FriendsSkeleton.module__header___QTRORD",
  "BS": "FriendsSkeleton.module__headerLeftSection___QTRORD",
  "Gv": "FriendsSkeleton.module__backButton___QTRORD",
  "cZ": "FriendsSkeleton.module__backButtonMobile___QTRORD",
  "LD": "FriendsSkeleton.module__headerLeft___QTRORD",
  "cP": "FriendsSkeleton.module__titleSection___QTRORD",
  "yF": "FriendsSkeleton.module__divider___QTRORD",
  "me": "FriendsSkeleton.module__tabsWrapper___QTRORD",
  "VD": "FriendsSkeleton.module__tabsInner___QTRORD",
  "IE": "FriendsSkeleton.module__headerRight___QTRORD",
  "Qs": "FriendsSkeleton.module__content___QTRORD",
  "sf": "FriendsSkeleton.module__searchWrapper___QTRORD",
  "MJ": "FriendsSkeleton.module__tabBody___QTRORD",
  "p_": "FriendsSkeleton.module__list___QTRORD",
  "p$": "FriendsSkeleton.module__emptyState___QTRORD",
  "AI": "FriendsSkeleton.module__emptyStateIcon___QTRORD",
  "vo": "FriendsSkeleton.module__emptyStateTitle___QTRORD",
  "F9": "FriendsSkeleton.module__emptyStateSubtitle___QTRORD",
  "Gf": "FriendsSkeleton.module__sectionTitle___QTRORD" + " " + __webpack_require__(530449)["Gf"],
  "Ge": "FriendsSkeleton.module__rows___QTRORD" + " " + __webpack_require__(530449)["f5"],
  "GF": "FriendsSkeleton.module__rowsWithMargin___QTRORD" + " " + __webpack_require__(530449)["v2"],
  "nM": "FriendsSkeleton.module__row___QTRORD",
  "z2": "FriendsSkeleton.module__rowInfo___QTRORD",
  "pt": "FriendsSkeleton.module__rowDetails___QTRORD",
  "hj": "FriendsSkeleton.module__rowNameBand___QTRORD",
  "f": "FriendsSkeleton.module__rowSubtextBand___QTRORD",
  "cm": "FriendsSkeleton.module__rowActions___QTRORD",
  "pz": "FriendsSkeleton.module__sidebar___QTRORD",
  "aN": "FriendsSkeleton.module__sidebarHeader___QTRORD",
  "wp": "FriendsSkeleton.module__sidebarContent___QTRORD",
  "rF": "FriendsSkeleton.module__sidebarEmptyState___QTRORD",
  "sM": "FriendsSkeleton.module__sidebarEmptyTitle___QTRORD",
  "iZ": "FriendsSkeleton.module__sidebarEmptyDescription___QTRORD",
  "KC": "FriendsSkeleton.module__sidebarEmptyDescriptionLine___QTRORD",
  "H4": "FriendsSkeleton.module__activeNowCard___QTRORD",
  "zO": "FriendsSkeleton.module__activeNowContextGroup___QTRORD",
  "vA": "FriendsSkeleton.module__activeNowStatus___QTRORD",
  "Ud": "FriendsSkeleton.module__activeNowContext___QTRORD",
  "dr": "FriendsSkeleton.module__activeNowParticipants___QTRORD",
  "$Q": "FriendsSkeleton.module__activeNowAction___QTRORD",
};

module.exports = exports;
